import React, { useState, useEffect } from 'react';
import { initAssignmentSession, initFreeExerciseSession } from './util/exercises-api.js';
import { ExerciseResumeDialog } from './components/dialogs/exercise-resume-dialog.js';
import { ExerciseRestartDialog } from './components/dialogs/exercise-restart-dialog.js';

function isAssignmentSession(response) {
    return 'isExpired' in response;
}
const ExercisePhaseSelector = ({ moduleId, medialinkId, assignmentId, tokenAccessor, onPhaseChange, onReview, onError, onClose, studioGroup, }) => {
    const [exerciseSession, setExerciseSession] = useState();
    useEffect(() => {
        async function getExerciseSessionInfo() {
            const token = await tokenAccessor.tokenGetter();
            return assignmentId
                ? initAssignmentSession(token, moduleId, assignmentId, studioGroup)
                : initFreeExerciseSession(token, moduleId, medialinkId, studioGroup);
        }
        getExerciseSessionInfo()
            .then(setExerciseSession)
            .catch(onError);
    }, [tokenAccessor, moduleId, medialinkId, assignmentId, onPhaseChange, onError, studioGroup]);
    useEffect(() => {
        if (exerciseSession && !exerciseSession.result)
            onPhaseChange('start');
    }, [exerciseSession, onPhaseChange]);
    const handleRestart = () => onPhaseChange('start');
    const handleResume = () => onPhaseChange('resume');
    if (exerciseSession && exerciseSession.result) {
        return exerciseSession.resumable ? (isAssignmentSession(exerciseSession) ? (React.createElement(ExerciseResumeDialog, { result: exerciseSession.result, onClose: onClose, onRestart: !exerciseSession.isExpired && exerciseSession.restartable ? handleRestart : undefined, onResume: !exerciseSession.isExpired ? handleResume : undefined })) : (React.createElement(ExerciseResumeDialog, { result: exerciseSession.result, onClose: onClose, onRestart: handleRestart, onResume: handleResume }))) : isAssignmentSession(exerciseSession) ? (React.createElement(ExerciseRestartDialog, { result: exerciseSession.result, onClose: onClose, onRestart: !exerciseSession.isExpired && exerciseSession.restartable ? handleRestart : undefined, onReview: onReview })) : (React.createElement(ExerciseRestartDialog, { result: exerciseSession.result, onClose: onClose, onRestart: handleRestart, onReview: onReview }));
    }
    return null;
};

export { ExercisePhaseSelector };
